/**
 * Transforme une chaîne de caractères en "slug" comme la fonction WP "sanitize_title".
 *
 * @param {string} str Chaîne de caractères à transformer.
 * @returns {string} Chaîne de caractères transformée en "slug".
 */
function ff_slugify(str) {
  str = str.replace(/^\s+|\s+$/g, '');
  str = str.toLowerCase();
  const from = 'àáäâèéëêìíïîòóöôùúüûñç·/_,:;';
  const to = 'aaaaeeeeiiiioooouuuunc------';
  for (let i = 0, l = from.length; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }
  str = str.replace(/[^a-z0-9 -]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');
  return str;
}

/**
 * Retire tous les sauts de ligne dans une chaîne de caractères.
 *
 * @param {string} str Chaîne de caractères à évaluer.
 * @returns {string} Chaîne de caractères sans sauts de ligne.
 */
function ff_remove_str_line_breaks(str) {
  return str.replace(/\s+/g, ' ').replace(/(\r\n|\n|\r)/gm, '');
}

/**
 * Splices text within a string.
 *
 * @param {string} str La chaîne de caractère à évaluer.
 * @param {number} offset The position to insert the text at (before).
 * @param {string} text The text to insert.
 * @param {number} [remove_count=0] An optional number of characters to overwrite.
 * @returns {string} A modified string containing the spliced text.
 */
function ff_splice_str(str, offset, text, remove_count = 0) {
  const calculated_offset = offset < 0 ? str.length + offset : offset;
  return str.substring(0, calculated_offset)
    + text + str.substring(calculated_offset + remove_count);
}

/**
 * Remplace toutes les occurences dans une châine de caractères.
 *
 * @param {string} subject La chaîne de caractères sur lequel on va effectuer la recherche et le remplacement.
 * @param {string} target La valeur à chercher.
 * @param {string} replacement La valeur de remplacement à substituer aux valeurs trouvées.
 * @returns {string} Chaîne contenant les valeurs remplacées.
 */
function ff_replace_all_in_str(subject, target, replacement) {
  return subject.split(target).join(replacement);
}

/**
 * Génère un identifiant unique.
 *
 * @param {string} [prefix=''] Préfixe à ajouter à l'identifiant.
 * @param {boolean} [random=false] Si oui ou non, une chaîne aléatoire doit être ajoutée à la fin de l'identifiant.
 * @returns {string} L'identifiant unique.
 */
function ff_uniqid(prefix = '', random = false) {
  const sec = Date.now() * 1000 + Math.random() * 1000;
  const id = sec.toString(16).replace(/\./g, '').padEnd(14, '0');
  return `${prefix}${id}${random ? `.${Math.trunc(Math.random() * 100000000)}` : ''}`;
}

/**
 * Vérifie si une chaîne de caractères donnée est un code hexadécimal.
 * @param {string} str Chaîne à vérifier.
 * @returns {boolean} Si oui ou non la chaîne est un code hexadécimal.
 */
function ff_is_hexadecimal(str) {
  return /^#[0-9A-Fa-f]+$/.test(str);
}

// Exportation
export {
  ff_slugify,
  ff_remove_str_line_breaks,
  ff_splice_str,
  ff_replace_all_in_str,
  ff_uniqid,
  ff_is_hexadecimal
};
